module.exports = __webpack_public_path__ + "img/expandWhiteboard.88dfd6d1.png";